module.exports = __webpack_public_path__ + "img/wifi.35fd5b4a.png";